import type * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SkillPathSkillFieldsFragment = { __typename?: 'GuideLevel', id: string, name: string, code?: string | null, myProficiencyLevel?: number | null, nearestSkillPathDueDate?: any | null };

export type ToDoSkillsQueryVariables = Types.Exact<{
  classroomIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type ToDoSkillsQuery = { __typename?: 'RootQueryType', subjects?: { __typename?: 'KeysetPageOfSubject', results?: Array<{ __typename?: 'Subject', id: string, name: string, urlSlug: string, guides: Array<{ __typename?: 'Guide', id: string, name: string, toDoSkills: Array<{ __typename?: 'GuideLevel', id: string, name: string, code?: string | null, myProficiencyLevel?: number | null, nearestSkillPathDueDate?: any | null }> }> }> | null } | null };

export type AllSkillsQueryVariables = Types.Exact<{
  classroomIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type AllSkillsQuery = { __typename?: 'RootQueryType', subjects?: { __typename?: 'KeysetPageOfSubject', results?: Array<{ __typename?: 'Subject', id: string, name: string, urlSlug: string, guides: Array<{ __typename?: 'Guide', id: string, name: string, allSkills: Array<{ __typename?: 'GuideLevel', id: string, name: string, code?: string | null, myProficiencyLevel?: number | null, nearestSkillPathDueDate?: any | null }> }> }> | null } | null };

export type AdaptiveAchievementQueryVariables = Types.Exact<{
  classroomIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type AdaptiveAchievementQuery = { __typename?: 'RootQueryType', adaptiveAchievement: any };

export const SkillPathSkillFieldsFragmentDoc = gql`
    fragment SkillPathSkillFields on GuideLevel {
  id
  name
  code
  myProficiencyLevel(classroomIds: $classroomIds)
  nearestSkillPathDueDate(classroomIds: $classroomIds)
}
    `;
export const ToDoSkillsDocument = gql`
    query ToDoSkills($classroomIds: [ID!]) {
  subjects(
    filter: {studentClassroomSubjects: {classroomId: {in: $classroomIds}, restrictFreePractice: {eq: false}}, adaptive: {eq: true}}
  ) {
    results {
      id
      name
      urlSlug
      guides(
        sort: [{field: NAME, order: ASC}]
        filter: {type: {eq: "adaptive"}, published: {eq: true}}
      ) {
        id
        name
        toDoSkills(classroomIds: $classroomIds) {
          ...SkillPathSkillFields
        }
      }
    }
  }
}
    ${SkillPathSkillFieldsFragmentDoc}`;

/**
 * __useToDoSkillsQuery__
 *
 * To run a query within a React component, call `useToDoSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useToDoSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useToDoSkillsQuery({
 *   variables: {
 *      classroomIds: // value for 'classroomIds'
 *   },
 * });
 */
export function useToDoSkillsQuery(baseOptions?: Apollo.QueryHookOptions<ToDoSkillsQuery, ToDoSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ToDoSkillsQuery, ToDoSkillsQueryVariables>(ToDoSkillsDocument, options);
      }
export function useToDoSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ToDoSkillsQuery, ToDoSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ToDoSkillsQuery, ToDoSkillsQueryVariables>(ToDoSkillsDocument, options);
        }
// @ts-ignore
export function useToDoSkillsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ToDoSkillsQuery, ToDoSkillsQueryVariables>): Apollo.UseSuspenseQueryResult<ToDoSkillsQuery, ToDoSkillsQueryVariables>;
export function useToDoSkillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ToDoSkillsQuery, ToDoSkillsQueryVariables>): Apollo.UseSuspenseQueryResult<ToDoSkillsQuery | undefined, ToDoSkillsQueryVariables>;
export function useToDoSkillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ToDoSkillsQuery, ToDoSkillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ToDoSkillsQuery, ToDoSkillsQueryVariables>(ToDoSkillsDocument, options);
        }
export type ToDoSkillsQueryHookResult = ReturnType<typeof useToDoSkillsQuery>;
export type ToDoSkillsLazyQueryHookResult = ReturnType<typeof useToDoSkillsLazyQuery>;
export type ToDoSkillsSuspenseQueryHookResult = ReturnType<typeof useToDoSkillsSuspenseQuery>;
export type ToDoSkillsQueryResult = Apollo.QueryResult<ToDoSkillsQuery, ToDoSkillsQueryVariables>;
export const AllSkillsDocument = gql`
    query AllSkills($classroomIds: [ID!]) {
  subjects(
    filter: {studentClassroomSubjects: {classroomId: {in: $classroomIds}, restrictFreePractice: {eq: false}}, adaptive: {eq: true}}
  ) {
    results {
      id
      name
      urlSlug
      guides(
        sort: [{field: NAME, order: ASC}]
        filter: {type: {eq: "adaptive"}, published: {eq: true}}
      ) {
        id
        name
        allSkills(classroomIds: $classroomIds) {
          ...SkillPathSkillFields
        }
      }
    }
  }
}
    ${SkillPathSkillFieldsFragmentDoc}`;

/**
 * __useAllSkillsQuery__
 *
 * To run a query within a React component, call `useAllSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSkillsQuery({
 *   variables: {
 *      classroomIds: // value for 'classroomIds'
 *   },
 * });
 */
export function useAllSkillsQuery(baseOptions?: Apollo.QueryHookOptions<AllSkillsQuery, AllSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSkillsQuery, AllSkillsQueryVariables>(AllSkillsDocument, options);
      }
export function useAllSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSkillsQuery, AllSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSkillsQuery, AllSkillsQueryVariables>(AllSkillsDocument, options);
        }
// @ts-ignore
export function useAllSkillsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllSkillsQuery, AllSkillsQueryVariables>): Apollo.UseSuspenseQueryResult<AllSkillsQuery, AllSkillsQueryVariables>;
export function useAllSkillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllSkillsQuery, AllSkillsQueryVariables>): Apollo.UseSuspenseQueryResult<AllSkillsQuery | undefined, AllSkillsQueryVariables>;
export function useAllSkillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllSkillsQuery, AllSkillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllSkillsQuery, AllSkillsQueryVariables>(AllSkillsDocument, options);
        }
export type AllSkillsQueryHookResult = ReturnType<typeof useAllSkillsQuery>;
export type AllSkillsLazyQueryHookResult = ReturnType<typeof useAllSkillsLazyQuery>;
export type AllSkillsSuspenseQueryHookResult = ReturnType<typeof useAllSkillsSuspenseQuery>;
export type AllSkillsQueryResult = Apollo.QueryResult<AllSkillsQuery, AllSkillsQueryVariables>;
export const AdaptiveAchievementDocument = gql`
    query AdaptiveAchievement($classroomIds: [ID!]) {
  adaptiveAchievement(classroomIds: $classroomIds)
}
    `;

/**
 * __useAdaptiveAchievementQuery__
 *
 * To run a query within a React component, call `useAdaptiveAchievementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdaptiveAchievementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdaptiveAchievementQuery({
 *   variables: {
 *      classroomIds: // value for 'classroomIds'
 *   },
 * });
 */
export function useAdaptiveAchievementQuery(baseOptions?: Apollo.QueryHookOptions<AdaptiveAchievementQuery, AdaptiveAchievementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdaptiveAchievementQuery, AdaptiveAchievementQueryVariables>(AdaptiveAchievementDocument, options);
      }
export function useAdaptiveAchievementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdaptiveAchievementQuery, AdaptiveAchievementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdaptiveAchievementQuery, AdaptiveAchievementQueryVariables>(AdaptiveAchievementDocument, options);
        }
// @ts-ignore
export function useAdaptiveAchievementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdaptiveAchievementQuery, AdaptiveAchievementQueryVariables>): Apollo.UseSuspenseQueryResult<AdaptiveAchievementQuery, AdaptiveAchievementQueryVariables>;
export function useAdaptiveAchievementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdaptiveAchievementQuery, AdaptiveAchievementQueryVariables>): Apollo.UseSuspenseQueryResult<AdaptiveAchievementQuery | undefined, AdaptiveAchievementQueryVariables>;
export function useAdaptiveAchievementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdaptiveAchievementQuery, AdaptiveAchievementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdaptiveAchievementQuery, AdaptiveAchievementQueryVariables>(AdaptiveAchievementDocument, options);
        }
export type AdaptiveAchievementQueryHookResult = ReturnType<typeof useAdaptiveAchievementQuery>;
export type AdaptiveAchievementLazyQueryHookResult = ReturnType<typeof useAdaptiveAchievementLazyQuery>;
export type AdaptiveAchievementSuspenseQueryHookResult = ReturnType<typeof useAdaptiveAchievementSuspenseQuery>;
export type AdaptiveAchievementQueryResult = Apollo.QueryResult<AdaptiveAchievementQuery, AdaptiveAchievementQueryVariables>;